import Spinner from "components/General-UI/Spinner";
import MoreOptionsTippy from "components/HOCS/MoreOptionsTippy";
import ArrowMore from "graphics/icons/General/ArrowMore";
import React, { useEffect, useState } from "react";

const DeviceSelector = ({ label, devices, currentDevice, selectDevice }) => {
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(
      devices.map((device) => {
        return {
          text: device.name,
          action: async () => {
            setDeviceLoading(true);
            await selectDevice(device.deviceId);
            setDeviceLoading(false);
          },
          active: currentDevice === device.deviceId,
          disabled: currentDevice === device.deviceId,
        };
      })
    );
  }, [devices, currentDevice, selectDevice]);

  return (
    <div className="device-info-row">
      <label htmlFor={`${label}devicelist`}>{label}</label>
      {devices[0] && deviceLoading && (
        <span className="Txt-change-permissions-loader">
          <Spinner
            bgDark={false}
            spinnerLight={false}
            immediateShow={true}
            small={true}
          />
        </span>
      )}
      <MoreOptionsTippy
        options={options}
        placement="bottom"
        offset={[0, 0]}
        customStyle={{ width: "265px", fontWeight: 600 }}
        disabled={!devices[0]}
      >
        <div
          id={`${label}devicelist`}
          className="device-static"
          style={{ pointerEvents: devices[0] ? "" : "none" }}
        >
          {devices[0] ? (
            <>
              <span className="texty  dotdotdot">
                {
                  devices.find((device) => currentDevice === device.deviceId)
                    .name
                }
              </span>

              <span className="arrow">
                <ArrowMore />
              </span>
            </>
          ) : (
            !deviceLoading && (
              <span>
                No other{" "}
                <span
                  style={{ textTransform: "lowercase" }}
                >{`${label}s`}</span>{" "}
                are detected
              </span>
            )
          )}
        </div>
        {/* <select
            id="audioOutputDevicesList"
            onChange={(e) => {
              setdeviceLoading(true);
              setAudioOutputDevice(e.target.value);
              setdeviceLoading(false);
            }}
            value={currentSpeakers}
          >
            {renderedDeviceList(devices)}
          </select> */}
      </MoreOptionsTippy>
    </div>
  );
};

export default DeviceSelector;
